import {
    Box,
    Select,
    Collapse,
    FormControl,
    Icon,
    VStack,
    Stack,
} from '@chakra-ui/react';

import Input from '../../../components/v4/Input';
import FormLabel from '../../../components/v4/FormLabel';

import walkthroughIds from '../walkthroughIds';
// import { Select } from 'chakra-react-select';
import { useSelector } from 'react-redux';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { useState, useEffect } from 'react';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
    textBoxStyling,
} from 'components/forms/new/formStyles';
import FieldToolTip from 'components/forms/new/FieldToolTip';

import useGetCurrentCompany from '@/queries/company/useGetCurrentCompany';
function AddressField({
    placeholder,
    fieldName,
    fieldValue,
    fieldHandler,
    inputWidth = true,
    helperText,
    isFocused,
    onBlur,
    onFocus,
    readOnly = false,
    isLocked = false, // Parent-level lock
    labelIndent = false, // Add indent to label
}) {
    const { darkMode } = useSelector((state) => state.settings);
    const effectiveReadOnly = readOnly || isLocked; // Locked overrides local readOnly

    return (
        <Stack direction="row" spacing={stackSpacing} sx={stackStyling(false)}>
            <FormLabel
                sx={{
                    ...formLabelStyling(darkMode),
                    paddingLeft: labelIndent ? '32px' : 0,
                }}>
                {placeholder}
            </FormLabel>
            <Box
                sx={{
                    display: 'flex',
                    width: '100%',
                    alignItems: 'flex-start',
                    paddingTop: '15px',
                }}>
                <VStack width={inputWidth && '100%'} alignItems="normal">
                    <Input
                        type="text"
                        id="fieldValue"
                        name="fieldValue"
                        value={fieldValue}
                        onChange={(e) =>
                            fieldHandler(fieldName, e.target.value)
                        }
                        sx={textBoxStyling}
                        onMouseOver={onFocus}
                        onBlur={onBlur}
                        readOnly={effectiveReadOnly}
                        isDisabled={isLocked}
                    />
                </VStack>
            </Box>
            {helperText && isFocused && (
                <FieldToolTip
                    label={helperText}
                    ariaLabel="admin-user-permission-set-tip"
                    left="25px"
                    top="25px"
                />
            )}
        </Stack>
        // <Box sx={{ margin: '0 0 25px' }}>
        //     <FormLabel sx={{ margin: '0 0 3px', fontSize: 'sm' }}>
        //         {placeholder}
        //     </FormLabel>
        //     <Input
        //         {...props}
        //         sx={{
        //             color: darkMode ? 'white' : '#000000de',
        //             borderColor: darkMode
        //                 ? 'dark.tcap-borderGray'
        //                 : '#0000003b',
        //             // borderRadius: '4px',
        //             maxWidth: 210,
        //             width: '100%',
        //             ...fieldStyles,
        //         }}
        //         value={fieldValue}
        //         onChange={(e) => fieldHandler(fieldName, e.target.value)}
        //         data-walkthroughid={props.dataWalkthroughId}
        //     />
        // </Box>
    );
}

export default function AddressFields({
    fields,
    fieldHandler,
    countries,
    isLocked = false,
    showStreetHouseNumber1Error = false,
}) {
    const { addresses } = walkthroughIds;
    const { darkMode } = useSelector((state) => state.settings);
    const [isBuildingOpen, setIsBuildingOpen] = useState(false);
    const [isMoreBuildingValuesOpen, setIsMoreBuildingValuesOpen] =
        useState(false);
    const [isStreetOpen, setIsStreetOpen] = useState(false);
    const [isMoreStreetValuesOpen, setIsMoreStreetValuesOpen] = useState(false);
    const [focusedField, setFocusedField] = useState(false);
    const { data: company } = useGetCurrentCompany();
    const companyName = company?.name;

    // Auto-expand Street section when validation error occurs
    useEffect(() => {
        if (showStreetHouseNumber1Error) {
            setIsStreetOpen(true);
        }
    }, [showStreetHouseNumber1Error]);

    return (
        <>
            <Box>
                <FormControl onFocus={() => setFocusedField('companyName')}>
                    <AddressField
                        placeholder="Company Name"
                        fieldName="companyName"
                        fieldValue={fields.companyName || companyName}
                        fieldHandler={fieldHandler}
                        fieldStyles={{
                            width: '350px',
                            maxWidth: '350px',
                        }}
                        labelText="test"
                        onFocus={() => setFocusedField('companyName')}
                        onBlur={() => setFocusedField(null)}
                        isFocused={focusedField === 'companyName'}
                        helperText="Enter the registered name of your company"
                        dataWalkthroughId={addresses.companyName}
                        readOnly={isLocked}
                        isLocked={isLocked}
                    />
                </FormControl>
                <Box
                    borderWidth="1.4px"
                    borderColor="#F5F5F5"
                    borderStyle="solid"
                    opacity="0.6"
                    my={4}></Box>
                <FormControl>
                    <AddressField
                        placeholder="Description"
                        fieldName="description"
                        fieldValue={fields.description}
                        fieldHandler={fieldHandler}
                        fieldStyles={{
                            width: '350px',
                            maxWidth: '350px',
                        }}
                        labelText="sample"
                        onFocus={() => setFocusedField('description')}
                        onBlur={() => setFocusedField(null)}
                        isFocused={focusedField === 'description'}
                        helperText="Enter the description for this address"
                        dataWalkthroughId={addresses.ufDescriptionInput}
                        readOnly={isLocked}
                        isLocked={isLocked}
                    />
                </FormControl>
                <Box
                    borderWidth="1.4px"
                    borderColor="#F5F5F5"
                    borderStyle="solid"
                    opacity="0.6"
                    my={4}></Box>
                <FormControl>
                    <Stack
                        direction="row"
                        spacing={stackSpacing}
                        sx={stackStyling(false)}>
                        <FormLabel sx={formLabelStyling(darkMode)}>
                            Country
                        </FormLabel>
                        <Box
                            sx={{
                                display: 'flex',
                                width: '100%',
                                alignItems: 'flex-start',
                                paddingTop: '15px',
                            }}>
                            <VStack width="100%" alignItems="normal">
                                <Select
                                    id="country"
                                    name="country"
                                    value={fields?.countryID}
                                    onChange={(event) => {
                                        const selectedCountryId =
                                            event.target.value;
                                        fieldHandler(
                                            'countryID',
                                            selectedCountryId,
                                        );
                                    }}
                                    sx={{
                                        ...textBoxStyling,
                                        borderColor: darkMode
                                            ? 'dark.tcap-borderGray'
                                            : '#0000003b',
                                        color: darkMode ? 'white' : '#000000de',
                                        backgroundColor: darkMode
                                            ? 'dark.bgDark'
                                            : 'white',
                                    }}
                                    disabled={
                                        !countries ||
                                        countries.length === 0 ||
                                        isLocked
                                    }
                                    isDisabled={isLocked}>
                                    {countries?.map((country) => (
                                        <option
                                            key={country.id}
                                            value={country.id}
                                            style={{
                                                backgroundColor: darkMode
                                                    ? '#121212'
                                                    : 'white',
                                                color: darkMode
                                                    ? 'white'
                                                    : '#000000de',
                                            }}>
                                            {country.name}
                                        </option>
                                    ))}
                                </Select>
                            </VStack>
                        </Box>
                    </Stack>
                </FormControl>
            </Box>
            <Box
                borderWidth="1.4px"
                borderColor="#F5F5F5"
                borderStyle="solid"
                opacity="0.6"
                my={4}></Box>
            {/* Building: Row 1 */}
            <Box>
                <Stack
                    direction="row"
                    spacing={stackSpacing}
                    sx={stackStyling(false)}
                    onClick={() => setIsBuildingOpen(!isBuildingOpen)}
                    cursor="pointer"
                    _hover={{ opacity: 0.8 }}>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Building
                    </FormLabel>
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            alignItems: 'center',
                            paddingTop: '15px',
                            justifyContent: 'flex-end',
                        }}>
                        <Icon
                            as={ChevronRightIcon}
                            boxSize={5}
                            color={darkMode ? 'whiteAlpha.700' : 'gray.500'}
                            transform={
                                isBuildingOpen ? 'rotate(90deg)' : 'none'
                            }
                            transition="transform 0.3s ease-in-out"
                        />
                    </Box>
                </Stack>
                <Collapse in={isBuildingOpen} animateOpacity>
                    <>
                        <FormControl>
                            <AddressField
                                placeholder="Building 1st Number"
                                fieldName="building1stNumber"
                                fieldValue={fields.building1stNumber}
                                fieldHandler={fieldHandler}
                                type="number"
                                dataWalkthroughId={`${addresses.ufBuildingNumberInput}/1`}
                                isLocked={isLocked}
                            />
                        </FormControl>
                        <Box
                            borderWidth="1.4px"
                            borderColor="#F5F5F5"
                            borderStyle="solid"
                            opacity="0.6"
                            my={4}></Box>
                        <FormControl>
                            <AddressField
                                placeholder="Building Floor Number"
                                fieldName="buildingFloorNumber"
                                fieldValue={fields.buildingFloorNumber}
                                fieldHandler={fieldHandler}
                                type="number"
                                dataWalkthroughId={
                                    addresses.ufBuildingFloorNumInput
                                }
                                isLocked={isLocked}
                            />
                        </FormControl>
                        <Box
                            borderWidth="1.4px"
                            borderColor="#F5F5F5"
                            borderStyle="solid"
                            opacity="0.6"
                            my={4}></Box>
                        <FormControl>
                            <AddressField
                                placeholder="Building Floor Number Suffix"
                                fieldName="buildingFloorNumberSuffix"
                                fieldValue={fields.buildingFloorNumberSuffix}
                                fieldHandler={fieldHandler}
                                dataWalkthroughId={
                                    addresses.ufBuildingFloorNumSuffixInput
                                }
                                isLocked={isLocked}
                            />
                        </FormControl>
                        <Box
                            borderWidth="1.4px"
                            borderColor="#F5F5F5"
                            borderStyle="solid"
                            opacity="0.6"
                            my={4}></Box>
                        <Box mt={4}>
                            <Stack
                                direction="row"
                                spacing={stackSpacing}
                                sx={{
                                    ...stackStyling(false),
                                    paddingLeft: '32px',
                                }}
                                onClick={() =>
                                    setIsMoreBuildingValuesOpen(
                                        !isMoreBuildingValuesOpen,
                                    )
                                }
                                cursor="pointer"
                                _hover={{ opacity: 0.8 }}>
                                <FormLabel sx={formLabelStyling(darkMode)}>
                                    More Building Values...
                                </FormLabel>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        width: '100%',
                                        alignItems: 'center',
                                        paddingTop: '15px',
                                        justifyContent: 'flex-end',
                                    }}>
                                    <Icon
                                        as={ChevronRightIcon}
                                        boxSize={5}
                                        color={
                                            darkMode
                                                ? 'whiteAlpha.700'
                                                : 'gray.500'
                                        }
                                        transform={
                                            isMoreBuildingValuesOpen
                                                ? 'rotate(90deg)'
                                                : 'none'
                                        }
                                        transition="transform 0.3s ease-in-out"
                                    />
                                </Box>
                            </Stack>
                        </Box>
                        <Collapse in={isMoreBuildingValuesOpen} animateOpacity>
                            <Box>
                                <FormControl>
                                    <AddressField
                                        placeholder="Building Type"
                                        fieldName="buildingType"
                                        fieldValue={fields.buildingType}
                                        fieldHandler={fieldHandler}
                                        inputWidth={false}
                                        fieldStyles={{
                                            width: '350px',
                                            maxWidth: '350px',
                                        }}
                                        dataWalkthroughId={
                                            addresses.ufBuildingTypeInput
                                        }
                                        isLocked={isLocked}
                                        labelIndent={true}
                                    />
                                </FormControl>
                                <Box
                                    borderWidth="1.4px"
                                    borderColor="#F5F5F5"
                                    borderStyle="solid"
                                    opacity="0.6"
                                    my={4}></Box>
                                <FormControl>
                                    <AddressField
                                        placeholder="Building 1st Suffix"
                                        inputWidth={false}
                                        fieldName="building1stSuffix"
                                        fieldValue={fields.building1stSuffix}
                                        fieldHandler={fieldHandler}
                                        dataWalkthroughId={`${addresses.ufBuildingSuffixInput}/1`}
                                        isLocked={isLocked}
                                        labelIndent={true}
                                    />
                                </FormControl>
                                <Box
                                    borderWidth="1.4px"
                                    borderColor="#F5F5F5"
                                    borderStyle="solid"
                                    opacity="0.6"
                                    my={4}></Box>
                                <FormControl>
                                    <AddressField
                                        placeholder="Building 2nd Number"
                                        inputWidth={false}
                                        fieldName="building2ndNumber"
                                        fieldValue={fields.building2ndNumber}
                                        fieldHandler={fieldHandler}
                                        type="number"
                                        dataWalkthroughId={`${addresses.ufBuildingNumberInput}/2`}
                                        isLocked={isLocked}
                                        labelIndent={true}
                                    />
                                </FormControl>
                                <Box
                                    borderWidth="1.4px"
                                    borderColor="#F5F5F5"
                                    borderStyle="solid"
                                    opacity="0.6"
                                    my={4}></Box>
                                <FormControl
                                    w={{ base: 'full', md: 'calc(50% - 8px)' }}>
                                    <AddressField
                                        placeholder="Building 2nd Suffix"
                                        inputWidth={false}
                                        fieldName="building2ndSuffix"
                                        fieldValue={fields.building2ndSuffix}
                                        fieldHandler={fieldHandler}
                                        dataWalkthroughId={`${addresses.ufBuildingSuffixInput}/2`}
                                        isLocked={isLocked}
                                        labelIndent={true}
                                    />
                                </FormControl>
                                <Box
                                    borderWidth="1.4px"
                                    borderColor="#F5F5F5"
                                    borderStyle="solid"
                                    opacity="0.6"
                                    my={4}></Box>
                                <FormControl
                                    w={{ base: 'full', md: 'calc(50% - 8px)' }}>
                                    <AddressField
                                        placeholder="Building Property"
                                        inputWidth={false}
                                        fieldName="buildingProperty"
                                        fieldValue={fields.buildingProperty}
                                        fieldHandler={fieldHandler}
                                        dataWalkthroughId={
                                            addresses.ufBuildingPropertyInput
                                        }
                                        isLocked={isLocked}
                                        labelIndent={true}
                                    />
                                </FormControl>
                                <Box
                                    borderWidth="1.4px"
                                    borderColor="#F5F5F5"
                                    borderStyle="solid"
                                    opacity="0.6"
                                    my={4}></Box>
                                <FormControl
                                    w={{ base: 'full', md: 'calc(50% - 8px)' }}>
                                    <AddressField
                                        placeholder="Building Location"
                                        inputWidth={false}
                                        fieldName="buildingLocation"
                                        fieldValue={fields.buildingLocation}
                                        fieldHandler={fieldHandler}
                                        dataWalkthroughId={
                                            addresses.ufBuildingLocationInput
                                        }
                                        isLocked={isLocked}
                                        labelIndent={true}
                                    />
                                </FormControl>
                            </Box>
                        </Collapse>
                    </>
                </Collapse>
            </Box>
            <Box
                borderWidth="1.4px"
                borderColor="#F5F5F5"
                borderStyle="solid"
                opacity="0.6"
                my={4}></Box>
            <Box mb={6}>
                <Stack
                    direction="row"
                    spacing={stackSpacing}
                    sx={stackStyling(false)}
                    onClick={() => setIsStreetOpen(!isStreetOpen)}
                    cursor="pointer"
                    _hover={{ opacity: 0.8 }}>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Street
                    </FormLabel>
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            alignItems: 'center',
                            paddingTop: '15px',
                            justifyContent: 'flex-end',
                        }}>
                        <Icon
                            as={ChevronRightIcon}
                            boxSize={5}
                            color={darkMode ? 'whiteAlpha.700' : 'gray.500'}
                            transform={isStreetOpen ? 'rotate(90deg)' : 'none'}
                            transition="transform 0.3s ease-in-out"
                        />
                    </Box>
                </Stack>
                <Collapse in={isStreetOpen} animateOpacity>
                    <FormControl
                        isInvalid={
                            showStreetHouseNumber1Error &&
                            (!fields.streetHouseNumber1 ||
                                fields.streetHouseNumber1.trim() === '')
                        }>
                        <AddressField
                            placeholder="Street House Number 1"
                            fieldName="streetHouseNumber1"
                            fieldValue={fields.streetHouseNumber1}
                            fieldHandler={fieldHandler}
                            type="number"
                            isRequired
                            dataWalkthroughId={`${addresses.ufStreetHouseNumInput}/1`}
                            isLocked={isLocked}
                        />
                        {/* {showStreetHouseNumber1Error && (!fields.streetHouseNumber1 || fields.streetHouseNumber1.trim() === '') && (
                            <FormErrorMessage ml="322px" mt={1}>Street House Number 1 is required</FormErrorMessage>
                        )} */}
                    </FormControl>
                    <Box
                        borderWidth="1.4px"
                        borderColor="#F5F5F5"
                        borderStyle="solid"
                        opacity="0.6"
                        my={4}></Box>
                    <FormControl w={{ base: 'full', md: 'calc(50% - 8px)' }}>
                        <AddressField
                            placeholder="Street Name 1"
                            fieldName="streetName1"
                            fieldValue={fields.streetName1}
                            fieldHandler={fieldHandler}
                            dataWalkthroughId={`${addresses.ufStreetNameInput}/1`}
                            isLocked={isLocked}
                        />
                    </FormControl>
                    <Box
                        borderWidth="1.4px"
                        borderColor="#F5F5F5"
                        borderStyle="solid"
                        opacity="0.6"
                        my={4}></Box>
                    <FormControl w={{ base: 'full', md: 'calc(50% - 8px)' }}>
                        <AddressField
                            placeholder="City / Locality"
                            fieldName="locality"
                            fieldValue={fields.locality}
                            fieldHandler={fieldHandler}
                            dataWalkthroughId={addresses.ufCityLocalityInput}
                            isLocked={isLocked}
                        />
                    </FormControl>
                    <Box
                        borderWidth="1.4px"
                        borderColor="#F5F5F5"
                        borderStyle="solid"
                        opacity="0.6"
                        my={4}></Box>
                    <FormControl w={{ base: 'full', md: 'calc(50% - 8px)' }}>
                        <AddressField
                            placeholder="District"
                            fieldName="district"
                            fieldValue={fields.district}
                            fieldHandler={fieldHandler}
                            dataWalkthroughId={addresses.ufDistrictInput}
                            isLocked={isLocked}
                        />
                    </FormControl>
                    <Box
                        borderWidth="1.4px"
                        borderColor="#F5F5F5"
                        borderStyle="solid"
                        opacity="0.6"
                        my={4}></Box>
                    <FormControl w={{ base: 'full', md: 'calc(50% - 8px)' }}>
                        <AddressField
                            placeholder="State"
                            fieldName="state"
                            fieldValue={fields.state}
                            fieldHandler={fieldHandler}
                            dataWalkthroughId={addresses.ufStateInput}
                            isLocked={isLocked}
                        />
                    </FormControl>
                    <Box
                        borderWidth="1.4px"
                        borderColor="#F5F5F5"
                        borderStyle="solid"
                        opacity="0.6"
                        my={4}></Box>
                    <FormControl w={{ base: 'full', md: 'calc(50% - 8px)' }}>
                        <AddressField
                            placeholder="ZIP / Post Code"
                            fieldName="postcode"
                            fieldValue={fields.postcode}
                            fieldHandler={fieldHandler}
                            dataWalkthroughId={addresses.ufZipCodeInput}
                            isLocked={isLocked}
                        />
                    </FormControl>
                    <Box
                        borderWidth="1.4px"
                        borderColor="#F5F5F5"
                        borderStyle="solid"
                        opacity="0.6"
                        my={4}></Box>
                    {/* Nested "More Street Values" collapsible accordion */}
                    <Box mt={4}>
                        <Stack
                            direction="row"
                            spacing={stackSpacing}
                            sx={{ ...stackStyling(false), paddingLeft: '32px' }}
                            onClick={() =>
                                setIsMoreStreetValuesOpen(
                                    !isMoreStreetValuesOpen,
                                )
                            }
                            cursor="pointer"
                            _hover={{ opacity: 0.8 }}>
                            <FormLabel sx={formLabelStyling(darkMode)}>
                                More Street Values...
                            </FormLabel>
                            <Box
                                sx={{
                                    display: 'flex',
                                    width: '100%',
                                    alignItems: 'center',
                                    paddingTop: '15px',
                                    justifyContent: 'flex-end',
                                }}>
                                <Icon
                                    as={ChevronRightIcon}
                                    boxSize={5}
                                    color={
                                        darkMode ? 'whiteAlpha.700' : 'gray.500'
                                    }
                                    transform={
                                        isMoreStreetValuesOpen
                                            ? 'rotate(90deg)'
                                            : 'none'
                                    }
                                    transition="transform 0.3s ease-in-out"
                                />
                            </Box>
                        </Stack>
                    </Box>
                    <Collapse in={isMoreStreetValuesOpen} animateOpacity>
                        <Box>
                            {/* <FormControl>
                                <AddressField
                                    placeholder="Street House Number 1"
                                    fieldName="streetHouseNumber1"
                                    fieldValue={fields.streetHouseNumber1}
                                    fieldHandler={fieldHandler}
                                    inputWidth={false}
                                    type="number"
                                    dataWalkthroughId={`${addresses.ufStreetHouseNumInput}/1`}
                                    isLocked={isLocked}
                                />
                            </FormControl> */}
                            {/* <Box borderWidth="1.4px" borderColor='#F5F5F5' borderStyle='solid' opacity='0.6' my={4}></Box> */}
                            <FormControl>
                                <AddressField
                                    placeholder="Street House Number 1 Suffix"
                                    fieldName="streetHouseNumber1Suffix"
                                    fieldValue={fields.streetHouseNumber1Suffix}
                                    inputWidth={false}
                                    fieldHandler={fieldHandler}
                                    dataWalkthroughId={`${addresses.ufStreetHouseNumSuffixInput}/1`}
                                    isLocked={isLocked}
                                    labelIndent={true}
                                />
                            </FormControl>
                            <Box
                                borderWidth="1.4px"
                                borderColor="#F5F5F5"
                                borderStyle="solid"
                                opacity="0.6"
                                my={4}></Box>
                            <FormControl>
                                <AddressField
                                    placeholder="Street House Number 2 Suffix"
                                    fieldName="streetHouseNumber2Suffix"
                                    fieldValue={fields.streetHouseNumber2Suffix}
                                    inputWidth={false}
                                    fieldHandler={fieldHandler}
                                    dataWalkthroughId={`${addresses.ufStreetHouseNumSuffixInput}/2`}
                                    isLocked={isLocked}
                                    labelIndent={true}
                                />
                            </FormControl>
                            <FormControl>
                                <AddressField
                                    placeholder="Street Type 1"
                                    fieldName="streetType1"
                                    fieldValue={fields.streetType1}
                                    inputWidth={false}
                                    fieldHandler={fieldHandler}
                                    dataWalkthroughId={`${addresses.ufStreetTypeInput}/1`}
                                    isLocked={isLocked}
                                    labelIndent={true}
                                />
                            </FormControl>
                            <Box
                                borderWidth="1.4px"
                                borderColor="#F5F5F5"
                                borderStyle="solid"
                                opacity="0.6"
                                my={4}></Box>
                            <FormControl>
                                <AddressField
                                    placeholder="Street Suffix 1"
                                    fieldName="streetSuffix1"
                                    inputWidth={false}
                                    fieldValue={fields.streetSuffix1}
                                    fieldHandler={fieldHandler}
                                    dataWalkthroughId={`${addresses.ufStreetSuffixInput}/1`}
                                    isLocked={isLocked}
                                    labelIndent={true}
                                />
                            </FormControl>
                            <Box
                                borderWidth="1.4px"
                                borderColor="#F5F5F5"
                                borderStyle="solid"
                                opacity="0.6"
                                my={4}></Box>
                            <FormControl>
                                <AddressField
                                    placeholder="Street Name 2"
                                    fieldName="streetName2"
                                    inputWidth={false}
                                    fieldValue={fields.streetName2}
                                    fieldHandler={fieldHandler}
                                    dataWalkthroughId={`${addresses.ufStreetNameInput}/2`}
                                    isLocked={isLocked}
                                    labelIndent={true}
                                />
                                <Box
                                    borderWidth="1.4px"
                                    borderColor="#F5F5F5"
                                    borderStyle="solid"
                                    opacity="0.6"
                                    my={4}></Box>
                            </FormControl>
                            <FormControl>
                                <AddressField
                                    placeholder="Street Type 2"
                                    fieldName="streetType2"
                                    inputWidth={false}
                                    fieldValue={fields.streetType2}
                                    fieldHandler={fieldHandler}
                                    dataWalkthroughId={`${addresses.ufStreetTypeInput}/2`}
                                    isLocked={isLocked}
                                    labelIndent={true}
                                />
                            </FormControl>
                            <Box
                                borderWidth="1.4px"
                                borderColor="#F5F5F5"
                                borderStyle="solid"
                                opacity="0.6"
                                my={4}></Box>
                            <FormControl
                                w={{ base: 'full', md: 'calc(50% - 8px)' }}>
                                <AddressField
                                    placeholder="Street Suffix 2"
                                    fieldName="streetSuffix2"
                                    fieldValue={fields.streetSuffix2}
                                    inputWidth={false}
                                    fieldHandler={fieldHandler}
                                    dataWalkthroughId={`${addresses.ufStreetSuffixInput}/2`}
                                    isLocked={isLocked}
                                    labelIndent={true}
                                />
                            </FormControl>
                        </Box>
                    </Collapse>
                </Collapse>
            </Box>
            {/* <Box borderWidth="1.4px" borderColor='#F5F5F5' borderStyle='solid' opacity='0.6' my={4}></Box>
            {/* Microsoft Locations Section (Accordion) */}
            {/* <Box w="775px" pt={6} mt={6}>
                <Button
                    onClick={() => setIsMicrosoftLocationsOpen(!isMicrosoftLocationsOpen)}
                    variant="unstyled"
                    w="775px"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    py={3}
                    _focus={{ boxShadow: 'outline' }}
                >
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Microsoft Locations
                    </FormLabel>
                    <Icon
                        as={ChevronRightIcon}
                        boxSize={5}
                        color={darkMode ? 'whiteAlpha.700' : 'gray.500'}
                        transform={isMicrosoftLocationsOpen ? 'rotate(90deg)' : 'none'}
                        transition="transform 0.3s ease-in-out"
                    />
                </Button>
                <Collapse in={isMicrosoftLocationsOpen} animateOpacity>
                    <FormControl>
                        <AddressField
                            placeholder="Location ID"
                            fieldName="locationID"
                            fieldValue={fields.locationID}
                            fieldHandler={fieldHandler}
                            dataWalkthroughId={addresses.locationID}
                        />
                    </FormControl>
                    <Box borderWidth="1.4px" borderColor='#F5F5F5' borderStyle='solid' opacity='0.6' my={4}></Box>
                    <FormControl>
                        <AddressField
                            placeholder="Civic address ID"
                            fieldName="civicAddressID"
                            fieldValue={fields.civicAddressID}
                            fieldHandler={fieldHandler}
                            dataWalkthroughId={addresses.civicAddressID}
                        />
                    </FormControl>
                    <Box borderWidth="1.4px" borderColor='#F5F5F5' borderStyle='solid' opacity='0.6' my={4}></Box>
                    <FormControl>
                        <AddressField
                            placeholder="Latitude"
                            fieldName="latitude"
                            fieldValue={fields.latitude}
                            fieldHandler={fieldHandler}
                            dataWalkthroughId={addresses.latitude}
                        />
                    </FormControl>
                    <Box borderWidth="1.4px" borderColor='#F5F5F5' borderStyle='solid' opacity='0.6' my={4}></Box>
                    <FormControl>
                        <AddressField
                            placeholder="Longitude"
                            fieldName="longitude"
                            fieldValue={fields.longitude}
                            fieldHandler={fieldHandler}
                            dataWalkthroughId={addresses.longitude}
                        />
                    </FormControl>
                </Collapse>
            </Box>
            <Box borderWidth="1.4px" borderColor='#F5F5F5' borderStyle='solid' opacity='0.6' my={4}></Box>
            <Box width="775px" pt={6} mt={6}>
                <Button
                    onClick={() => setIsOtherOpen(!isOtherOpen)}
                    variant="unstyled"
                    width="775px"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    py={3}
                    style={{ marginBottom: '16px' }}
                    _focus={{ boxShadow: 'outline' }}
                >
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Other
                    </FormLabel>
                    <Icon
                        as={ChevronRightIcon}
                        boxSize={5}
                        color={darkMode ? 'whiteAlpha.700' : 'gray.500'}
                        transform={isOtherOpen ? 'rotate(90deg)' : 'none'}
                        transition="transform 0.3s ease-in-out"
                    />
                </Button>
                <Collapse in={isOtherOpen} animateOpacity>
                    <FormControl>
                        <AddressField
                            placeholder="Google Place ID"
                            fieldName="googlePlaceID"
                            fieldValue={fields.googlePlaceID}
                            fieldHandler={fieldHandler}
                            readOnly
                        />
                    </FormControl>
                </Collapse>
            </Box> */}
        </>
    );
}
